import { Component } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

@Component({
    mixins: [ProjectMixin],
    inheritAttrs: false,
})
export default class AddButton extends Mixins<MixinInterface>(ProjectMixin) {}
